module.exports = __webpack_public_path__ + "img/Banner02.a2173d90.png";